module.exports = __webpack_public_path__ + "img/masoutis_back.1088e63e.png";